module.exports = __webpack_public_path__ + "static/media/CompanyDefaultUser.2f3a1fbe.svg";